var map = {
	"./diagonal-bottom-left.png": "1b84",
	"./diagonal-bottom-right.png": "fbb1",
	"./diagonal-top-left.png": "df4b",
	"./diagonal-top-right.png": "0ab9",
	"./horizontal-bottom-left.png": "b60f",
	"./horizontal-bottom-right.png": "d8bd",
	"./horizontal-top-left.png": "e2ee",
	"./horizontal-top-right.png": "8b5e",
	"./spiral-anticlockwise-middle.png": "c16d",
	"./spiral-anticlockwise-top-right.png": "8b5d",
	"./spiral-clockwise-middle.png": "a893",
	"./spiral-clockwise-top-right.png": "3374",
	"./vertical-bottom-left.png": "9244",
	"./vertical-bottom-right.png": "af72",
	"./vertical-top-left.png": "2819",
	"./vertical-top-right.png": "f837"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b8ed";